import translationMenu from '../data/translationMenu';

/**
 * Label for a menu variant size in cart, checkout, and order views.
 * Supports multilingual objects ({ en, fa, ... }) and catalog keys mapped in translationMenu.sizes.
 */
export function getVariantSizeDisplay(size, currentLanguage) {
    if (size == null || size === '') return '';

    if (typeof size === 'object' && !Array.isArray(size)) {
        const localized = size[currentLanguage] || size.en;
        if (localized != null && String(localized).trim() !== '') {
            return String(localized);
        }
        const first = Object.values(size).find((v) => v != null && String(v).trim() !== '');
        return first != null ? String(first) : '';
    }

    const key = String(size);
    return (
        translationMenu[currentLanguage]?.sizes?.[key] ||
        translationMenu.en?.sizes?.[key] ||
        key
    );
}
